import { Components, Theme } from "@mui/material/styles";

export const MuiLink = (theme: Theme) =>
  ({
    MuiLink: {
      styleOverrides: {
        root: {
          color: theme.palette.primary.main,
          textDecoration: "none",
        },
      },
    },
  }) satisfies Components<Theme>;
